module.exports = __webpack_public_path__ + "img/material-symbols_folder-open-outline-rounded.d366b9e7.svg";